__turbopack_context__.v({
  "background": "styles-module-scss-module__GbCQjq__background",
  "bgFirst": "styles-module-scss-module__GbCQjq__bgFirst",
  "bgSecond": "styles-module-scss-module__GbCQjq__bgSecond",
  "bgThird": "styles-module-scss-module__GbCQjq__bgThird",
  "circle": "styles-module-scss-module__GbCQjq__circle",
  "circleDarkMode": "styles-module-scss-module__GbCQjq__circleDarkMode",
  "circleFirst": "styles-module-scss-module__GbCQjq__circleFirst",
  "circleFirstDarkMode": "styles-module-scss-module__GbCQjq__circleFirstDarkMode",
  "circleSecond": "styles-module-scss-module__GbCQjq__circleSecond",
  "circleSecondDarkMode": "styles-module-scss-module__GbCQjq__circleSecondDarkMode",
  "circleThird": "styles-module-scss-module__GbCQjq__circleThird",
  "circleThirdDarkMode": "styles-module-scss-module__GbCQjq__circleThirdDarkMode",
  "container": "styles-module-scss-module__GbCQjq__container",
  "containerDarkMode": "styles-module-scss-module__GbCQjq__containerDarkMode",
  "prefixSubtitle": "styles-module-scss-module__GbCQjq__prefixSubtitle",
  "root": "styles-module-scss-module__GbCQjq__root",
  "stepNumber": "styles-module-scss-module__GbCQjq__stepNumber",
  "text": "styles-module-scss-module__GbCQjq__text",
  "title": "styles-module-scss-module__GbCQjq__title",
  "titleFirst": "styles-module-scss-module__GbCQjq__titleFirst",
});
